import React from "react";
import { Dropdown, Tag, Tooltip } from "antd";
import { More } from "assets/icons";
import theme from "styles/theme";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/ViewDocument.styled";

const ViewDocument = ({ record, documents, handlesClick }): JSX.Element => {
  const QUANTITY_DOCUMENT = useTranslation({ id: "quantity_documents" });
  const VIEW_DOCUMENT = useTranslation({ id: "view_documents" });

  return (
    <S.DocumentContainer>
      <Tooltip placement="top" title={QUANTITY_DOCUMENT}>
        <S.DocumentTag>
          <Tag key={record.id} color={theme.colors.grayTag} className="documentTag" data-testid="quantity_documents">
            {documents === undefined || documents?.length === 0 ? "0" : documents?.length}
          </Tag>
        </S.DocumentTag>
      </Tooltip>
      {documents?.length === 0 ? (
        <span>
          <Tooltip placement="top" title={VIEW_DOCUMENT}>
            <More className="moreIconDisabled" data-testid="view_documents_disabled_icon" />
          </Tooltip>
        </span>
      ) : (
        <Dropdown trigger={["click"]} overlay={handlesClick.handleClickViewDocument(record)} placement="topLeft">
          <button onClick={(e) => e.preventDefault()}>
            <Tooltip placement="top" title={VIEW_DOCUMENT}>
              <More className="moreIcon" data-testid="view_documents_icon" />
            </Tooltip>
          </button>
        </Dropdown>
      )}
    </S.DocumentContainer>
  );
};

export default ViewDocument;
